/* Cannavé — interacciones */
(function () {
  // Menú móvil
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Formato de precio
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'COP';
    var digits = cur === 'COP' || cur === 'CLP' ? 0 : 2;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-CO', { style: 'currency', currency: cur, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(digits); }
  }

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    // Cantidad
    var qty = form.querySelector('.qty__input');
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    // Variantes
    var dataEl = form.querySelector('[data-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) {}
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-btn]');
    var addLabel = form.querySelector('[data-add-label]');
    var priceEls = document.querySelectorAll('[data-price]');
    var fieldsets = form.querySelectorAll('.opts');
    var labels = { add: addLabel ? addLabel.textContent : '', sold: 'Agotado' };

    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function update() {
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) { if (addBtn) addBtn.disabled = true; return; }
      idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addLabel.textContent = v.available ? labels.add : labels.sold; }
      priceEls.forEach(function (p) {
        var now = p.querySelector('.price__now'); if (now) now.textContent = money(v.price);
        var was = p.querySelector('.price__was');
        if (was) { if (v.compare_at_price > v.price) { was.hidden = false; was.lastChild.textContent = money(v.compare_at_price); } else { was.hidden = true; } }
        var badge = p.querySelector('.price__badge');
        if (badge) { if (v.compare_at_price > v.price) { badge.hidden = false; badge.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; } else { badge.hidden = true; } }
      });
      if (history.replaceState && document.body.classList.contains('template-product')) {
        var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
  });

  // Galería
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('[data-slide]');
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-thumb'), 10);
        slides.forEach(function (s, k) { s.hidden = k !== i; });
        g.querySelectorAll('[data-thumb]').forEach(function (o) { o.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  // Barra de compra fija en móvil
  var sticky = document.querySelector('[data-sticky-buy]');
  var mainForm = document.querySelector('.product-main [data-product-form]');
  if (sticky && mainForm && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    sticky.style.transform = 'translateY(110%)';
    sticky.style.transition = 'transform .25s';
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = e.boundingClientRect.top < 0;
      sticky.style.transform = (!e.isIntersecting && below) ? 'none' : 'translateY(110%)';
    }).observe(mainForm);
    sticky.querySelector('[data-sticky-buy-btn]').addEventListener('click', function () {
      mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
})();

/* Ritual: los pasos se activan al bajar */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-ritual]').forEach(function (sec) {
    var track = sec.querySelector('.ritual__track');
    var steps = sec.querySelectorAll('[data-rt-step]');
    var imgs = sec.querySelectorAll('[data-rt-img]');
    var bar = sec.querySelector('[data-rt-bar]');
    var ring = sec.querySelector('.ritual__ring');
    var n = steps.length;
    if (!n) return;
    function setActive(k) {
      steps.forEach(function (el, i) { el.classList.toggle('is-on', i === k); });
      imgs.forEach(function (el, i) { el.classList.toggle('is-on', i === k); });
    }
    if (reduce) { steps.forEach(function (el) { el.classList.add('is-on'); }); return; }
    var ticking = false;
    function frame() {
      ticking = false;
      var r = track.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      var p = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0;
      setActive(Math.min(n - 1, Math.floor(p * n)));
      if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
      if (ring) ring.style.transform = 'rotate(' + (p * 90 - 20).toFixed(1) + 'deg)';
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  });
})();

/* Testimonios en video: uno a la vez, con sonido */
(function () {
  document.querySelectorAll('[data-vtest]').forEach(function (sec) {
    var rail = sec.querySelector('[data-vt-rail]');
    var cards = sec.querySelectorAll('.vcard');
    function stopAll(except) {
      cards.forEach(function (c) {
        var v = c.querySelector('video');
        if (v && c !== except) { v.pause(); v.controls = false; c.classList.remove('is-playing'); }
      });
    }
    cards.forEach(function (card) {
      var btn = card.querySelector('[data-vt-play]');
      var v = card.querySelector('video');
      if (!btn || !v) return;
      btn.addEventListener('click', function () {
        stopAll(card);
        v.muted = false; v.controls = true;
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        card.classList.add('is-playing');
      });
      v.addEventListener('pause', function () { if (v.ended || v.paused) card.classList.remove('is-playing'); v.controls = false; });
      v.addEventListener('play', function () { card.classList.add('is-playing'); });
    });
    var step = function () { var c = cards[0]; return c ? c.getBoundingClientRect().width + 16 : 300; };
    var prev = sec.querySelector('[data-vt-prev]'), next = sec.querySelector('[data-vt-next]');
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) stopAll(null); }); }, { threshold: 0 }).observe(sec);
    }
  });
})();

/* Barra de anuncio: mensajes rotativos + cuenta regresiva */
(function () {
  document.querySelectorAll('[data-announce]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('[data-msg]');
    if (msgs.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, 3500);
    }
    var cd = bar.querySelector('[data-countdown]');
    if (!cd) return;
    var end = new Date(cd.getAttribute('data-countdown').replace(' ', 'T'));
    if (isNaN(end)) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var s = Math.floor((end - new Date()) / 1000);
      if (s <= 0) { cd.hidden = true; return false; }
      cd.hidden = false;
      cd.querySelector('[data-cd-d]').textContent = pad(Math.floor(s / 86400));
      cd.querySelector('[data-cd-h]').textContent = pad(Math.floor(s % 86400 / 3600));
      cd.querySelector('[data-cd-m]').textContent = pad(Math.floor(s % 3600 / 60));
      cd.querySelector('[data-cd-s]').textContent = pad(s % 60);
      return true;
    }
    if (tick()) { var t = setInterval(function () { if (!tick()) clearInterval(t); }, 1000); }
  });
})();

/* Antes y después deslizable */
(function () {
  document.querySelectorAll('[data-ba]').forEach(function (f) {
    var r = f.querySelector('[data-ba-range]');
    if (!r) return;
    var set = function () { f.style.setProperty('--pos', r.value + '%'); };
    var auto = f.getAttribute('data-ba-auto');
    var stopped = false;
    r.addEventListener('input', function () { stopped = true; set(); });
    f.addEventListener('pointerdown', function () { stopped = true; });
    set();
    if (!auto || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var hold = (parseFloat(auto) || 2) * 1000, dur = 1300;
    function tween(from, to, done) {
      var t0 = null;
      function step(ts) {
        if (stopped) return;
        if (t0 === null) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur);
        var e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
        r.value = from + (to - from) * e; set();
        if (k < 1) requestAnimationFrame(step); else setTimeout(done, hold);
      }
      requestAnimationFrame(step);
    }
    function cycle() { if (stopped) return; tween(100, 0, function () { if (!stopped) tween(0, 100, cycle); }); }
    var started = false;
    var go = function () { if (started) return; started = true; r.value = 100; set(); setTimeout(cycle, hold); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { go(); io.disconnect(); } }, { threshold: .35 });
      io.observe(f);
    } else { go(); }
  });
})();

/* Aparición suave al hacer scroll */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  if (window.Shopify && Shopify.designMode) return;
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  document.documentElement.classList.add('js-reveal');
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el, i) { el.style.transitionDelay = (i % 3) * 0.08 + 's'; io.observe(el); });
})();

/* Ingredientes que aparecen al bajar */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-gscroll]').forEach(function (sec) {
    var track = sec.querySelector('.gscroll__track');
    var items = sec.querySelectorAll('[data-gs-item]');
    var gum = sec.querySelector('[data-gs-gum]');
    var count = sec.querySelector('[data-gs-count]');
    var n = items.length;
    if (reduce) { items.forEach(function (i) { i.classList.add('is-on'); }); if (count) count.textContent = n; return; }
    var ticking = false;
    function frame() {
      ticking = false;
      var r = track.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      var p = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 1;
      var shown = Math.min(n, Math.floor(p * (n + 1.5)));
      items.forEach(function (el, i) { el.classList.toggle('is-on', i < shown); });
      if (count) count.textContent = shown;

    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  });
})();


/* Portada: productos girando hacia la izquierda */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-spin]').forEach(function (ring) {
    var items = ring.querySelectorAll('[data-spin-item]');
    var n = items.length;
    if (!n) return;
    var speed = (parseFloat(ring.getAttribute('data-speed')) || 4) * 0.00006;
    var t = 0, last = null, paused = false;
    function place() {
      var w = ring.clientWidth;
      var R = w * 0.36;
      items.forEach(function (el, i) {
        var a = t + i * 2 * Math.PI / n;
        var x = -Math.sin(a) * R;
        var d = (Math.cos(a) + 1) / 2;          /* 1 = al frente, 0 = atrás */
        var s = 0.55 + d * 0.45;
        el.style.transform = 'translate(-50%, -50%) translateX(' + x.toFixed(1) + 'px) translateY(' + ((1 - d) * -18).toFixed(1) + 'px) scale(' + s.toFixed(3) + ')';
        el.style.zIndex = Math.round(d * 100);
        el.style.opacity = (0.45 + d * 0.55).toFixed(2);
        el.style.filter = 'brightness(' + (0.55 + d * 0.45).toFixed(2) + ')';
        el.classList.toggle('is-front', d > 0.93);
      });
    }
    ring.classList.add('is-ready');
    place();
    if (reduce) return;
    ring.addEventListener('mouseenter', function () { paused = true; });
    ring.addEventListener('mouseleave', function () { paused = false; });
    function loop(ts) {
      if (last !== null && !paused) t += (ts - last) * speed;
      last = ts; place(); requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
    window.addEventListener('resize', place);
  });
})();

/* Próximos lanzamientos: el producto aparece de borroso a nítido */
(function () {
  var items = document.querySelectorAll('.soon__item');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) { items.forEach(function (i) { i.classList.add('is-revealed'); }); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
  }, { threshold: .45 });
  items.forEach(function (i) { io.observe(i); });
})();

/* Ingredientes girando alrededor de los productos, sin salir del área bajo el título */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-gscroll]').forEach(function (sec) {
    var stage = sec.querySelector('.gscroll__stage');
    var center = sec.querySelector('.gscroll__center');
    var chips = Array.prototype.slice.call(sec.querySelectorAll('.gscroll__col .gs-chip'));
    if (!stage || !center || !chips.length) return;
    // intercalar izquierda/derecha para repartir alrededor
    var L = chips.filter(function (c) { return c.closest('.gscroll__col--l'); });
    var R = chips.filter(function (c) { return c.closest('.gscroll__col--r'); });
    var order = []; for (var i = 0; i < Math.max(L.length, R.length); i++) { if (L[i]) order.push(L[i]); if (R[i]) order.push(R[i]); }
    var n = order.length, t = 0, last = null, on = false, geo = null;
    function measure() {
      var w = stage.clientWidth, h = stage.clientHeight;
      var chipH = 0, chipW = 0;
      order.forEach(function (c) { chipH = Math.max(chipH, c.offsetHeight); chipW = Math.max(chipW, c.offsetWidth); });
      // productos: que quepan dentro de la órbita
      var rx = w / 2 - chipW / 2 - 6, ry = Math.max(40, h / 2 - chipH / 2 - 4);
      var tw = Math.min(w * 0.42, 560);
      stage.style.setProperty('--trio-w', tw + 'px');
      var k = center.offsetHeight / Math.max(1, center.offsetWidth) || 0.55;
      // reducir los productos hasta que la órbita de los ingredientes no los toque
      for (var g = 0; g < 40; g++) {
        var ex = (tw / 2 + chipW / 2 + 10) / rx, ey = (k * tw / 2 + chipH / 2 + 8) / ry;
        if (ex * ex + ey * ey <= 1) break;
        tw *= 0.95;
      }
      stage.style.setProperty('--trio-w', tw + 'px');
      geo = { cx: w / 2, cy: h / 2, rx: rx, ry: ry };
    }
    function place() {
      if (!geo) return;
      order.forEach(function (c, i) {
        var a = t + i * 2 * Math.PI / n - Math.PI / 2;
        c.style.left = (geo.cx + Math.cos(a) * geo.rx).toFixed(1) + 'px';
        c.style.top = (geo.cy + Math.sin(a) * geo.ry).toFixed(1) + 'px';
      });
    }
    function enable() {
      var want = window.innerWidth >= 900;
      if (want && !on) { stage.classList.add('is-orbit'); on = true; }
      if (!want && on) { stage.classList.remove('is-orbit'); on = false; order.forEach(function (c) { c.style.left = c.style.top = ''; }); }
      if (on) { measure(); place(); }
    }
    function loop(ts) {
      if (on && !reduce) { if (last !== null) t -= (ts - last) * 0.00012; place(); }
      last = ts; requestAnimationFrame(loop);
    }
    enable(); window.addEventListener('resize', enable); window.addEventListener('load', enable);
    center.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', enable); });
    requestAnimationFrame(loop);
  });
})();


/* Cannavé: carrito → pago contra entrega (Releasit) */
(function(){
  function ready(){return window._rsiV2&&typeof window._rsiV2.setState==='function';}
  function openCart(){try{window._rsiV2.setState({isOpen:true,triggerCartUpdate:Date.now()});}catch(e){window.location.href='/checkout';}}
  function openProduct(pid,vid){
    var R=window._rsiV2,go=function(){try{R.setState({products:[],productWithUpsells:{upsells:[],currentIndex:0},currentProductId:pid,currentVariantId:vid,triggerCartUpdate:Date.now(),isOpen:true});}catch(e){openCart();}};
    try{var st=R.getState&&R.getState(),cid=st&&st.cartInfo&&st.cartInfo.id,cs=R.cartService;
      if(cid&&cs&&typeof cs.clearCart==='function'){var done=false,t=setTimeout(function(){if(!done){done=true;go();}},2500);Promise.resolve(cs.clearCart(cid)).catch(function(){}).then(function(){if(!done){done=true;clearTimeout(t);go();}});}
      else go();}catch(e){go();}
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('button[name="checkout"],input[name="checkout"],a[href="/checkout"],a[href^="/checkout?"]');
    if(!b||!ready())return;
    e.preventDefault();e.stopPropagation();
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var it=cart.items||[];
      if(it.length===1&&it[0].quantity===1){openProduct(it[0].product_id,it[0].variant_id);}else{openCart();}
    }).catch(openCart);
  },true);
})();
